export enum ObrPlottingEventType {
  StartPinDrop,
  StopPinDrop,
  SendDetails,
  SendAnnotations,
  PlotObservations,
  DeletePoints,
  DeleteAnnotations
}
